import React from 'react';
import * as S from './styles';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';

interface RequestErrorModalProps {
  show: boolean;
  isLoading: boolean;
  onClose: () => void;
  onProceed: () => void;
}

const RequestErrorModal: React.FC<RequestErrorModalProps> = ({
  show,
  isLoading,
  onClose,
  onProceed
}) => {
  const getText = useTranslationHelper();

  const handleProceed = () => {
    onProceed();
  };

  return (
    <S.StyledModal
      id="request-error-update-modal"
      show={show}
      onClose={onClose}
      header={
        <S.ModalTitle>
          {getText('modal.requestErrorTitle', 'Something went wrong')}
        </S.ModalTitle>
      }
      maxWidth="480px"
      closeOnBlur={false}
      closeButton={true}
      footer={
        <S.Footer>
          <S.ProceedButton
            onClick={handleProceed}
            appearance="primary"
            loading={isLoading}
          >
            {getText('modal.requestTryAgain', 'Try Again')}
          </S.ProceedButton>
        </S.Footer>
      }
      alignFooter="end"
    >
      <S.ModalContent>
        <S.FirstParagraph>
          {getText(
            'modal.requestErrorDescription',
            'There was an issue with your upgrade request. Please try again.'
          )}
        </S.FirstParagraph>
      </S.ModalContent>
    </S.StyledModal>
  );
};

export default RequestErrorModal;
